var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row mb-3 header-edit" }, [
    _c(
      "div",
      {
        staticClass:
          "col-12 col-lg-11 col-xl-11 col-md-11 pr-0 heavy-items-wrapper"
      },
      [
        _c(
          "div",
          {
            staticClass:
              "heavy-items-orange position-relative flex-column flex-lg-row flex-xl-row flex-md-row"
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "col-3" }, [
              _c(
                "p",
                {
                  on: {
                    click: function($event) {
                      _vm.editable && _vm.toggleHasHeavyItems()
                    }
                  }
                },
                [
                  _c("span", [_vm._v("No")]),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "switch",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                        }
                      }
                    },
                    [
                      _c("input", {
                        attrs: { type: "checkbox" },
                        domProps: { checked: _vm.data.has_heavy_items }
                      }),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "check-slider round",
                        class: _vm.editable ? "" : "disabled"
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    { class: _vm.data.has_heavy_items ? "yes-active" : "" },
                    [_vm._v("Yes")]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-4 inputs" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.data.has_heavy_items,
                      expression: "data.has_heavy_items"
                    }
                  ],
                  staticClass: "row"
                },
                [
                  _c("div", { staticClass: "col-6" }, [
                    _c(
                      "div",
                      {
                        staticClass: "select-wrap amount-wrap",
                        class:
                          _vm.modelHeavyItemsFee && !_vm.editing
                            ? "border-0"
                            : ""
                      },
                      [
                        _c("label", [_vm._v("Heavy items fee")]),
                        _vm._v(" "),
                        _c("span", { staticClass: "dollar" }, [_vm._v("$")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.heavyItemsFee,
                              expression: "heavyItemsFee"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            disabled:
                              (_vm.modelHeavyItemsFee && !_vm.editing) ||
                              !_vm.editable
                          },
                          domProps: { value: _vm.heavyItemsFee },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.heavyItemsFee = $event.target.value
                            }
                          }
                        })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6" }, [
                    _vm.modelHeavyItemsFee && !_vm.editing
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { type: "button", disabled: !_vm.editable },
                            on: {
                              click: function($event) {
                                _vm.editing = true
                              }
                            }
                          },
                          [_vm._v("\n              Edit\n            ")]
                        )
                      : _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { type: "button", disabled: !_vm.editable },
                            on: { click: _vm.saveHeavyItemsFee }
                          },
                          [_vm._v("\n              Save\n            ")]
                        )
                  ])
                ]
              )
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-5 flex" }, [
      _c("span", { staticClass: "mod-icon-weight d-inline-block mr-3" }),
      _vm._v(" "),
      _c("p", [_vm._v("Are there heavy items for this move?")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e1cb6838", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e1cb6838","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeavyItemsDisclaimer.vue
// module id = null
// module chunks = 